import React from 'react';

import { Step, StepButton, StepLabel, Stepper } from '@mui/material';

import { STEPS } from './constants';
import { getStepProgress } from './stepClearanceUtils';
import { getStepIconSx } from './stepperStyles';

interface Props {
  activeStep: number;
  canGoToStep: (step: number) => boolean;
  clearedThrough: number;
  hasSucceeded: boolean;
  isBusy: boolean;
  onJumpToStep: (step: number) => void;
}

export default function WizardStepper({
  activeStep,
  canGoToStep,
  clearedThrough,
  hasSucceeded,
  isBusy,
  onJumpToStep,
}: Props) {
  return (
    // nonLinear: a linear Stepper auto-disables every step after the active one, which would block the
    // jump forward to steps already cleared. Each step's done/clickable state is set explicitly below.
    <Stepper
      nonLinear
      activeStep={hasSucceeded ? STEPS.length : activeStep}
      alternativeLabel
      // Top padding leaves room for the current step's halo, which the dialog's scroll area would clip.
      sx={{ mb: 4, pt: 1 }}
    >
      {STEPS.map((step, index) => {
        const isCurrent = !hasSucceeded && index === activeStep;
        const progress = getStepProgress({ clearedThrough, hasSucceeded, step: index });
        const canJump = !isBusy && !hasSucceeded && canGoToStep(index);

        return (
          <Step key={step.label} sx={getStepIconSx({ isCurrent, progress })}>
            {canJump ? (
              <StepButton onClick={() => onJumpToStep(index)}>{step.label}</StepButton>
            ) : (
              <StepLabel>{step.label}</StepLabel>
            )}
          </Step>
        );
      })}
    </Stepper>
  );
}
